var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.546,25.627L32,42.087l-15.546-16.46c-0.758-0.804-2.024-0.839-2.827-0.081c-0.803,0.758-0.839,2.024-0.081,2.827l17,18 C30.924,46.773,31.45,47,32,47s1.076-0.227,1.454-0.627l17-18c0.758-0.803,0.722-2.069-0.081-2.827 C49.57,24.788,48.305,24.824,47.546,25.627z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,0C23.452,0,15.417,3.329,9.373,9.374C3.329,15.417,0,23.453,0,32s3.329,16.583,9.373,22.626 C15.417,60.671,23.452,64,32,64s16.583-3.329,22.626-9.374C60.671,48.583,64,40.547,64,32s-3.33-16.583-9.374-22.626 C48.583,3.329,40.548,0,32,0z M51.797,51.798C46.51,57.087,39.479,60,32,60c-7.479,0-14.51-2.913-19.799-8.202 C6.913,46.51,4,39.479,4,32s2.913-14.51,8.202-19.798C17.49,6.913,24.521,4,32,4c7.479,0,14.51,2.913,19.798,8.203 C57.087,17.491,60,24.521,60,32S57.087,46.509,51.797,51.798z",
    fill: "#858585"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.94d519e4d1232b0bff477630b59b3ef4.svg";
export { ForwardRef as ReactComponent };